import { render, staticRenderFns } from "./TurmoilAgenda.vue?vue&type=template&id=abb44646"
import script from "./TurmoilAgenda.vue?vue&type=script&lang=ts"
export * from "./TurmoilAgenda.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports